import { c as _c } from "react/compiler-runtime";
import { docs } from '../config';
import css from './links.module.scss';
export function Links() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.links}><p>Quick Links</p><ul>{docs.links.map(_temp)}</ul></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(link) {
  return <li key={link.title} className={css.item}><span>{link.icons}</span><a target="_blank" href={link.url}>{link.title}</a></li>;
}